(function() {
    'use strict';
    /**
     * @memberof wbDashboard
     * @ngdoc Services
     * @name Notification
     * @description Notification service to handle notification data
     */
    angular.module('wbDashboard').factory('ThinkingService', ['$q', '$rootScope', '$timeout', '$uibModal', function ($q, $rootScope, $timeout, $uibModal) {

        var thinking = {
            modalInstances: {}
        };

        thinking.open = function($scope, key, copy) {
            /*jshint -W030 */
            copy || (copy = {});
            /*jshint +W030 */

            if (key in thinking.modalInstances && thinking.modalInstances[key].opened) {
                //already opened
                return thinking.modalInstances[key];
            }

            if (!copy.thinking) {
                copy.thinking = "Doing Some Thinking";
            }
            if (!copy.complete) {
                copy.complete = "Great! <br/> Finished Thinking";
            }

            //must be rootScope or it will close when changing pages
            var modalScope = $rootScope.$new(true);
            modalScope.pageData = $scope.pageData || {thinking:true};
            modalScope.copy = copy;
            thinking.modalInstances[key] = $uibModal.open({
                templateUrl: "app/themes/aurea/templates/modal.thinking.tpl.html",
                scope: modalScope,
                size: 'full',
                windowClass:'thinking-modal slide-up-up'
            });

            thinking.modalInstances[key].opened = true;
            thinking.modalInstances[key].result.catch(angular.noop).finally(function() {
                thinking.modalInstances[key].opened = false;
            });

            return thinking.modalInstances[key];
        };

        thinking.close = function(imediate, key) {
            if (!(key in thinking.modalInstances)) {
                throw new Error("ThinkingService: Error, missing thinking: " + key);
            }
            if (!thinking.modalInstances[key].opened) {
                return $q.defer();
            }

            var time = imediate ? 0 : 750;
            return $timeout(function() {
                thinking.modalInstances[key].close();
            }, time);
        };

        return thinking;

    }]);
})();
